import api from "./Api";

class ReceberPagamentoService {
  GetReceberPagamento(payload) {
    return api.get("/v1/receberPagamento/" + payload).then((response) => {
      return response.data;
    });
  }

  PostReceberPagamento(payload) {
    return api.post("/v1/receberPagamento/", payload).then((response) => {
      return response.data;
    });
  }

  PutReceberPagamento(payload) {
    return api.put("/v1/receberPagamento/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteReceberPagamento(payload) {
    return api.delete("/v1/receberPagamento/" + payload).then((response) => {
      return response.data;
    });
  }

  GetReceberPagamentoOData(payload) {
    return api.get("/OData/ReceberPagamento" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ReceberPagamentoService();
